<template>
  <div v-if="boo_modal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0, 0, 0, 0.5)">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header bg-main text-white py-2">
          <h6 class="modal-title mb-0">
            <i class="fas fa-file-invoice me-2"></i>{{ title }}
          </h6>
          <button type="button" class="btn-close btn-close-white" @click="mtdClose"></button>
        </div>

        <div class="modal-body p-3">
          <div v-if="bills.length > 0" class="table-responsive">
            <p id="mydesc-bills"></p>
            <table class="table table-bordered" aria-describedby="mydesc-bills" style="font-size: 11px">
              <thead class="bg-main text-white text-center" style="font-size: 9px">
                <tr>
                  <th scope="col" class="align-middle">N° FACTURA</th>
                  <th scope="col" class="align-middle">F. FACTURA</th>
                  <th scope="col" class="align-middle">F. VENCIMIENTO</th>
                  <th scope="col" class="align-middle">F. TENTATIVA</th>
                  <th scope="col" class="align-middle">MONEDA</th>
                  <th scope="col" class="align-middle">TOTAL</th>
                </tr>
              </thead>
              <tbody class="border-main text-center" style="font-size: 10px">
                <tr v-for="(bill, idx) in bills" :key="idx" class="tbody-table">
                  <td class="align-middle">{{ bill.number ?? '-' }}</td>
                  <td class="align-middle">{{ bill.bill_date ?? '-' }}</td>
                  <td class="align-middle">{{ bill.bill_due_date ?? '-' }}</td>
                  <td class="align-middle">{{ bill.tentative_date ?? '-' }}</td>
                  <td class="align-middle">{{ bill.money ?? '-' }}</td>
                  <td class="align-middle">{{ bill.total ?? '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-center py-3 text-muted" style="font-size: 12px">
            <i class="fas fa-info-circle me-1"></i> No se encontraron facturas
            para esta orden.
          </div>
        </div>

        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-secondary" @click="mtdClose">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cModalViewBills",
  props: {
    title: {
      type: String,
      default: "",
    },
    boo_modal: {
      type: Boolean,
      default: false,
    },
    bills: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    mtdClose: function () {
      this.$emit("mtdCloseModalViewBills");
    },
  },
};
</script>